module.exports = __webpack_public_path__ + "img/hzico_3.9f36c8c6.jpg";